import {Interval} from '../../../classes/Matm';

declare const THREE: any;

export abstract class EnvironmentScenarioBase extends (THREE.Object3D as { new(): any; }) {

  private static removeAllLights(scene) {
    const lights = [];
    scene.traverse(obj => {
      if (obj instanceof THREE.Light) {
        lights.push(obj);
      }
    });
    lights.forEach(light => light.parent.remove(light));
  }


  constructor(scene?) {
    super();
    if (scene) {
      EnvironmentScenarioBase.removeAllLights(scene);
      this.add(...scene.children);
    }
    this.name = 'environment';
  }

  abstract setDayLight(input: Interval);

}




// WEBPACK FOOTER //
// ./src/app/custom/env/scenarios/EnvironmentScenarioBase.ts